(function () {
  'use strict';
  const instances = new WeakMap();

  function init(form) {
    if (!form || !form.matches('[data-armore-product-form]') || instances.has(form)) return;
    const variantInput = form.querySelector('[data-armore-variant-id]');
    if (variantInput) variantInput.disabled = false;
    const abort = new AbortController();
    const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, {...options, signal: abort.signal});
    const advanced = form.querySelector('[data-advsz]');
    const inputs = () => Array.from(form.querySelectorAll('[data-single-option-selector]'));
    const error = form.querySelector('[data-armore-size-error]');
    let closeTimer;
    let frame;
    let lastFocus;
    let previousOverflow;
    let opened = false;
    let guideHydrated = false;
    let guideView = 'list'; // list | menu | detail
    let activeCategory = 'ring';

    function syncSwatches() {
      form.querySelectorAll('.swatch-view-item').forEach(item => {
        const radio = item.querySelector('input[data-single-option-selector]');
        if (!radio) return;
        item.setAttribute('aria-checked', String(radio.checked));
        item.tabIndex = radio.checked ? 0 : -1;
        item.querySelector('.swatch-selector')?.classList.toggle('swatch-selected', radio.checked);
      });
    }

    function selectInput(input, value) {
      if (!input) return false;
      if (input.type === 'radio') input.checked = true;
      else input.value = value;
      input.dispatchEvent(new Event('input', {bubbles: true}));
      input.dispatchEvent(new Event('change', {bubbles: true}));
      return true;
    }

    function chooseSwatch(item) {
      if (!item || item.closest('form') !== form) return;
      const radio = item.querySelector('input[data-single-option-selector]');
      if (!radio || radio.disabled || item.getAttribute('aria-disabled') === 'true') return;
      if (!radio.checked) selectInput(radio, radio.value);
      syncSwatches();
    }

    listen(form, 'click', event => {
      const item = event.target.closest('.swatch-view-item');
      if (item && event.target.tagName !== 'INPUT') chooseSwatch(item);
    });
    listen(form, 'keydown', event => {
      const item = event.target.closest('.swatch-view-item');
      if (!item || item.closest('form') !== form) return;
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        chooseSwatch(item);
      } else if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) {
        const items = Array.from(item.parentElement.children).filter(el => el.matches('.swatch-view-item') && el.getAttribute('aria-disabled') !== 'true');
        const index = items.indexOf(item);
        const step = ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1;
        const next = event.key === 'Home' ? items[0] : event.key === 'End' ? items[items.length - 1] : items[(index + step + items.length) % items.length];
        if (next) { event.preventDefault(); chooseSwatch(next); next.focus(); }
      }
    });
    listen(form, 'change', syncSwatches);
    syncSwatches();

    let restore = syncSwatches;
    let close = () => {};
    if (advanced) {
      const index = 'option' + (Number(advanced.dataset.optIndex) + 1);
      const sizeInputs = () => inputs().filter(input => input.dataset.index === index);
      const selectedValue = () => sizeInputs().find(input => input.type !== 'radio' || input.checked)?.value;
      const overlay = advanced.querySelector('.advsz__overlay');
      const modal = advanced.querySelector('.advsz__modal');
      const trigger = advanced.querySelector('.advsz__trigger');
      const triggerText = advanced.querySelector('.advsz__trigger-text');
      const back = advanced.querySelector('.advsz__back');
      const list = advanced.querySelector('[data-panel="list"]');
      const menu = advanced.querySelector('[data-panel="guide-menu"]');
      const guide = advanced.querySelector('[data-panel="guide"]');
      const slot = advanced.querySelector('[data-guide-slot]');
      const title = advanced.querySelector('.advsz__title');
      const buttons = Array.from(advanced.querySelectorAll('.advsz__option'));
      const payment = form.querySelector('[data-armore-payment]');
      const nativeWrapper = sizeInputs()[0]?.closest('.selector-wrapper');
      if (nativeWrapper) nativeWrapper.hidden = true;

      function syncSize() {
        const value = selectedValue();
        const chosen = advanced.dataset.selected === 'true' && buttons.some(button => button.dataset.optionValue === value);
        advanced.dataset.selected = String(chosen);
        buttons.forEach(button => {
          const selected = chosen && button.dataset.optionValue === value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        triggerText.textContent = chosen ? advanced.dataset.sizeLabel + ' ' + value : advanced.dataset.unselectedLabel;
        if (payment) payment.hidden = !chosen;
        const idInputs = form.querySelectorAll('input[name="id"], select[name="id"]');
        if (!chosen) {
          idInputs.forEach(input => {
            input.value = '';
            input.disabled = true;
          });
        } else {
          idInputs.forEach(input => {
            input.disabled = false;
          });
        }
        if (chosen && error) { error.hidden = true; error.textContent = ''; }
        trigger.setAttribute('aria-invalid', String(!chosen && !!error && !error.hidden));
      }

      function hideAllPanels() {
        if (list) list.hidden = true;
        if (menu) menu.hidden = true;
        if (guide) guide.hidden = true;
      }

      function showList() {
        hideAllPanels();
        if (list) list.hidden = false;
        back.classList.add('advsz__back--hidden');
        title.textContent = advanced.dataset.chooseTitle;
        guideView = 'list';
        modal.setAttribute('data-view', 'list');
      }

      function showMenu() {
        hideAllPanels();
        if (menu) menu.hidden = false;
        else if (guide) guide.hidden = false; // fallback if menu markup absent
        back.classList.remove('advsz__back--hidden');
        title.textContent = 'SIZE GUIDE';
        guideView = 'menu';
        modal.setAttribute('data-view', 'menu');
      }

      function hydrateRingGuide() {
        if (guideHydrated || !slot) return;
        const preferred = advanced.dataset.guideSection;
        const source = (preferred && document.getElementById('shopify-section-' + preferred)) || form.closest('[data-section-id]')?.querySelector('[data-advsg="root"]') || document.querySelector('[data-advsg="root"]');
        const content = source?.querySelector('[data-advsg-wrap]');
        if (content) { slot.innerHTML = content.innerHTML; guideHydrated = true; }
      }

      function normalizeCategory(category) {
        if (!category) return 'rings';
        return category === 'ring' ? 'rings' : category;
      }

      function setCategory(category) {
        const cat = normalizeCategory(category);
        activeCategory = cat;
        if (!guide) return;
        guide.querySelectorAll('[data-sg-tab]').forEach(tab => {
          const tabCat = normalizeCategory(tab.getAttribute('data-sg-tab'));
          const selected = tabCat === cat;
          tab.setAttribute('aria-selected', String(selected));
          tab.setAttribute('tabindex', selected ? '0' : '-1');
        });
        guide.querySelectorAll('[data-sg-panel]').forEach(panel => {
          const panelCat = normalizeCategory(panel.getAttribute('data-sg-panel'));
          panel.hidden = panelCat !== cat;
        });
      }

      function showDetail(category) {
        hideAllPanels();
        if (guide) guide.hidden = false;
        back.classList.remove('advsz__back--hidden');
        title.textContent = 'SIZE GUIDE';
        guideView = 'detail';
        modal.setAttribute('data-view', 'detail');
        setCategory(category || activeCategory || 'rings');
      }

      function finishClose(restoreFocus) {
        clearTimeout(closeTimer);
        cancelAnimationFrame(frame);
        overlay.classList.remove('is-open');
        overlay.hidden = true;
        modal.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (opened) document.documentElement.style.overflow = previousOverflow;
        opened = false;
        if (restoreFocus && lastFocus?.isConnected) lastFocus.focus();
      }
      close = (immediate = false, restoreFocus = true) => {
        if (!opened) return;
        overlay.classList.remove('is-open');
        clearTimeout(closeTimer);
        if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) finishClose(restoreFocus);
        else closeTimer = setTimeout(() => finishClose(restoreFocus), 1000);
      };

      function open() {
        clearTimeout(closeTimer);
        if (!opened) {
          lastFocus = document.activeElement;
          previousOverflow = document.documentElement.style.overflow;
        }
        opened = true;
        showList();
        overlay.hidden = false;
        modal.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        frame = requestAnimationFrame(() => { overlay.classList.add('is-open'); modal.focus(); });
      }

      function requireSize(event) {
        if (advanced.dataset.selected === 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const idInputs = form.querySelectorAll('input[name="id"], select[name="id"]');
        idInputs.forEach(input => {
          input.value = '';
          input.disabled = true;
        });
        if (error) { error.textContent = advanced.dataset.requiredMessage; error.hidden = false; }
        trigger.setAttribute('aria-invalid', 'true');
        open();
      }
      listen(form, 'submit', requireSize, {capture: true});
      listen(form, 'click', event => {
        if (event.target.closest('[data-add-to-cart], .shopify-payment-button, [data-armore-payment]')) requireSize(event);
      }, {capture: true});
      try {
        const origSubmit = form.submit;
        form.submit = function() {
          if (advanced.dataset.selected !== 'true') {
            const idInputs = form.querySelectorAll('input[name="id"], select[name="id"]');
            idInputs.forEach(input => { input.value = ''; input.disabled = true; });
            open();
            return false;
          }
          return origSubmit.apply(form, arguments);
        };
      } catch (err) {}
      listen(trigger, 'click', open);
      listen(overlay, 'click', event => { if (event.target === overlay) close(); });
      listen(advanced.querySelector('.advsz__close'), 'click', () => close());
      listen(back, 'click', () => {
        if (guideView === 'detail') {
          showMenu();
          advanced.querySelector('[data-sg-open], [data-sg-open-category]')?.focus();
        } else {
          showList();
          advanced.querySelector('[data-open-guide]')?.focus();
        }
      });
      listen(modal, 'keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(modal.querySelectorAll('button:not([disabled]), a[href], input, select, textarea, [tabindex="0"]')).filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[hidden]'));
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!first) { event.preventDefault(); modal.focus(); }
        else if (event.shiftKey && (document.activeElement === first || document.activeElement === modal)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || document.activeElement === modal)) { event.preventDefault(); first.focus(); }
      });

      const guideButton = advanced.querySelector('[data-open-guide]');
      if (guideButton) listen(guideButton, 'click', () => {
        // Required flow: Size chart and tips → category MENU (not ring guide directly)
        if (menu) {
          showMenu();
          menu.querySelector('[data-sg-open], [data-sg-open-category]')?.focus();
        } else {
          showDetail('rings');
          back.focus();
        }
      });

      if (menu) {
        menu.querySelectorAll('[data-sg-open], [data-sg-open-category]').forEach(row => {
          listen(row, 'click', () => {
            const cat = row.getAttribute('data-sg-open') || row.getAttribute('data-sg-open-category') || 'rings';
            showDetail(cat);
            guide?.querySelector('[data-sg-tab][aria-selected="true"]')?.focus();
          });
        });
      }
      if (guide) {
        guide.querySelectorAll('[data-sg-tab]').forEach(tab => {
          listen(tab, 'click', () => setCategory(tab.getAttribute('data-sg-tab') || 'rings'));
        });

        // Wire accordions
        guide.querySelectorAll('details').forEach(details => {
          listen(details, 'toggle', () => {
            const summary = details.querySelector('summary, .hdt-sg__acc-summary');
            if (summary) summary.setAttribute('aria-expanded', String(details.open));
          });
        });

        // Wire CM / IN unit toggle
        guide.querySelectorAll('[data-sg-unit]').forEach(btn => {
          listen(btn, 'click', () => {
            const unit = btn.getAttribute('data-sg-unit');
            if (!unit) return;
            guide.setAttribute('unit', unit);
            guide.querySelectorAll('[data-sg-unit]').forEach(b => {
              b.setAttribute('aria-pressed', String(b.getAttribute('data-sg-unit') === unit));
            });
          });
        });
      }

      buttons.forEach(button => listen(button, 'click', () => {
        const value = button.dataset.optionValue;
        const input = sizeInputs().find(input => input.type !== 'radio' || input.value === value);
        if (!input) return;
        advanced.dataset.selected = 'true';
        selectInput(input, value);
        const idInputs = form.querySelectorAll('input[name="id"], select[name="id"]');
        idInputs.forEach(i => { i.disabled = false; });
        syncSize();
        close();
      }));
      listen(form, 'change', event => {
        if (sizeInputs().includes(event.target) && event.isTrusted) advanced.dataset.selected = 'true';
        syncSize();
      });
      restore = () => { close(true, false); syncSwatches(); syncSize(); };
      syncSize();
    }
    const instance = {destroy() { close(true, false); clearTimeout(closeTimer); cancelAnimationFrame(frame); abort.abort(); instances.delete(form); }, restore};
    instances.set(form, instance);
    listen(window, 'pageshow', event => { if (event.persisted && form.isConnected) restore(); });
  }

  const forms = root => root.querySelectorAll('[data-armore-product-form]');
  function showError(root, message) {
    let error = root.querySelector('[data-armore-cart-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'errors';
      error.setAttribute('data-armore-cart-error', '');
      error.setAttribute('role', 'status');
      error.setAttribute('aria-live', 'polite');
      root.appendChild(error);
    }
    error.textContent = message;
  }
  window.ArmoreProductOptions = {init, showError, destroy(form) { instances.get(form)?.destroy(); }};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => forms(document).forEach(init), {once: true});
  else forms(document).forEach(init);
  document.addEventListener('shopify:section:load', event => forms(event.target).forEach(init));
  document.addEventListener('shopify:section:unload', event => forms(event.target).forEach(form => instances.get(form)?.destroy()));
})();
